import { render, staticRenderFns } from "./EventDefine2Detail.vue?vue&type=template&id=75b2f084&scoped=true&"
import script from "./EventDefine2Detail.vue?vue&type=script&lang=js&"
export * from "./EventDefine2Detail.vue?vue&type=script&lang=js&"
import style0 from "./EventDefine2Detail.vue?vue&type=style&index=0&id=75b2f084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b2f084",
  null
  
)

export default component.exports